import React from 'react';
import { compose } from 'redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
// Core components
import TextField from 'components/core/TextField';
import { ContainedButton } from 'components/core/Button';
import Box from 'components/core/Box';
import Paper from 'components/core/Paper';
import Typography from 'components/core/Typography';
import Link from 'components/core/Link';
// Models
import mProduct from 'models/product';
// Custom
import { authShape } from 'constants/PropTypesShapes';
import { buildFormErrors, signinConstraints } from 'utils/Forms';
import withFormManagement from 'hocs/WithFormManagement';
import withStateReinit from 'hocs/WithStateReinit';
import withTitle from 'hocs/WithTitle';
import ErrorsDisplayer from 'components/misc/ErrorsDisplayer';
import PasswordInputField from 'components/inputFields/PasswordInputField';
import { OneparkLogoWhiteImg } from 'components/img/AssetImg';
import LangSelector from 'components/misc/LangSelector';
import ForgotPasswordForm from './ForgotPasswordForm';

class FormContainer extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      form: 'signin',
    };
  }

  // Handlers
  handleSubmit(e) {
    e.preventDefault();
    const {
      fields: { email, password },
      onErrorsChange,
      handleSignIn,
    } = this.props;

    const errors = buildFormErrors({ email, password }, signinConstraints);
    // Apply errors
    onErrorsChange(errors);

    // No error => validate form
    if (!errors) {
      handleSignIn({
        email,
        password,
      });
    }
  }

  render() {
    const {
      fields: { email, password },
      auth,
      errors,
      onFieldsChange,
      handleRecoverPassword,
    } = this.props;
    const { form } = this.state;

    return (
      <div style={{ maxWidth: '600px', margin: 'auto' }}>
        <Paper>
          <Box type="primary" style={{ position: 'relative' }}>
            <section className="p-4">{OneparkLogoWhiteImg(null, 60)}</section>
            <div style={{ position: 'absolute', bottom: 4, right: 12 }}>
              <Typography type="homeTitle" align="right">
                <LocalizedMessage id={mProduct.fromValue().labelId} />
              </Typography>
            </div>
          </Box>
          <div
            className="px-4"
            style={{
              position: 'relative',
              paddingTop: 48,
              paddingBottom: 48,
            }}
          >
            {/* -----  LANG SELECTOR ----- */}
            <div style={{ position: 'absolute', top: 24, right: 20 }}>
              <LangSelector />
            </div>
            {/* -----  SHOW ERROR ----- */}
            {_get(errors, 'global') !== 'form' && <ErrorsDisplayer errors={errors} />}
            {/* ----- Sign In ----- */}
            {form === 'signin' && (
            <form onSubmit={this.handleSubmit} noValidate>
              <TextField
                type="email"
                name="email"
                label={<LocalizedMessage id="field.email" />}
                value={email}
                errorText={_get(errors, 'email')}
                onChange={(value) => onFieldsChange({ email: value })}
              />
              <PasswordInputField
                label={<LocalizedMessage id="field.password" />}
                value={password}
                errorText={_get(errors, 'password')}
                onChange={(value) => onFieldsChange({ password: value })}
              />
              <div className="text-center" style={{ paddingTop: 36 }}>
                <ContainedButton type="submit" label={<LocalizedMessage id="button.login" />} />
              </div>
            </form>
            )}

            {/* ----- Forgot Password ----- */}
            {form === 'forgotPassword' && <ForgotPasswordForm auth={auth} onSubmit={handleRecoverPassword} />}
          </div>
        </Paper>
        {/* Link  */}
        <div className="pt-4 text-center">
          {form === 'signin' ? (
            <Link
              onClick={() => {
                this.setState({
                  form: 'forgotPassword',
                });
              }}
            >
              <LocalizedMessage id="info.forgotPassword" />
            </Link>
          ) : (
            <Link
              onClick={() => {
                this.setState({
                  form: 'signin',
                });
              }}
            >
              <LocalizedMessage id="info.signin" />
            </Link>
          )}
        </div>
      </div>
    );
  }
}

FormContainer.propTypes = {
  auth: authShape.isRequired, // eslint-disable-line react/no-unused-prop-types
  fields: PropTypes.object.isRequired,
  errors: PropTypes.object,
  onFieldsChange: PropTypes.func.isRequired,
  onErrorsChange: PropTypes.func.isRequired,
  handleSignIn: PropTypes.func.isRequired,
  handleRecoverPassword: PropTypes.func.isRequired,
};

FormContainer.defaultProps = {
  errors: null,
};

const mapFieldsToProps = {
  email: {
    defaultValue: '',
  },
  password: {
    defaultValue: '',
  },
};

const mapOwnPropsToResources = (ownProps) => ({
  operationError: ownProps.auth.error,
});

module.exports = compose(
  withFormManagement(mapFieldsToProps, mapOwnPropsToResources, false),
  withStateReinit(['auth']),
  withTitle('pageTitle.login'),
)(FormContainer);



// WEBPACK FOOTER //
// ./routes/login/components/opac/FormContainer.js